import {ChevronLeftIcon, ChevronRightIcon} from "@heroicons/react/solid";
import React from "react";

type SwitcherProps = {
  previousText?: string
  nextText?: string
  text: string
  onPress: () => void
  onPressPrevious: () => void
  onPressNext: () => void
}

function Switcher({previousText = 'Previous', nextText = 'Next', text, onPress, onPressPrevious, onPressNext}: SwitcherProps) {
  return (
    <div className="flex items-center rounded-md shadow-sm md:items-stretch">
      <button
        type="button"
        className="flex items-center justify-center rounded-l-md border border-r-0 border-gray-300 bg-white py-2 pl-3 pr-4 text-gray-400 hover:text-gray-500 md:w-9 md:px-2 md:hover:bg-gray-50 focus-visible:outline-brand"
        onClick={onPressPrevious}
      >
        <span className="sr-only">{previousText}</span>
        <ChevronLeftIcon className="h-5 w-5" aria-hidden="true"/>
      </button>
      <button type="button"
              className="hidden border-t border-b border-gray-300 bg-white px-3.5 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900 md:block focus-visible:outline-brand"
              onClick={onPress}
      >
        {text}
      </button>
      <span className="relative -mx-px h-5 w-px bg-gray-300 md:hidden"/>
      <button
        type="button"
        className="flex items-center justify-center rounded-r-md border border-l-0 border-gray-300 bg-white py-2 pl-4 pr-3 text-gray-400 hover:text-gray-500 md:w-9 md:px-2 md:hover:bg-gray-50 focus-visible:outline-brand"
        onClick={onPressNext}
      >
        <span className="sr-only">{nextText}</span>
        <ChevronRightIcon className="h-5 w-5" aria-hidden="true"/>
      </button>
    </div>
  )
}

export default Switcher